<template>
  <div>
    <el-menu
      background-color="#3C5179"
      text-color="#fff"
      active-text-color="#4460C4"
      unique-opened
      :collapse="isCollapse"
      :collapse-transition="false"
      :router="true"
      :default-active="$route.path"
    >
      <sidebar-item :menu="getrouters()" />
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './sidebarItem/SidebarItem'

import db from '@/services/localstorage'

export default {
  components: { SidebarItem },
  data() {
    return {
      isCollapse: false,
    }
  },
  methods: {
    getrouters() {
      //路由表
      return db.get('USER_ROUTER')[0].children
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.is-active {
  background-color: #fff !important;
  i {
    color: rgb(68, 96, 196) !important;
  }
}

.el-menu {
  width: 100%;
}
/deep/.el-submenu__title {
  i {
    color: #fff;
  }
  span {
    display: inline-block;
    width: 103px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/deep/.el-menu-item {
  span {
    display: inline-block;
    width: 135px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  i {
    color: #fff;
  }
}

//------------------------------------------------------------------------
// navbar收缩后  文字 图标不隐藏，深度监听覆盖
/*隐藏文字*/
/deep/.el-menu--collapse .el-submenu__title span {
  display: none;
}
/*隐藏 > */
/deep/.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

/deep/.el-menu--collapse .el-menu-item {
  color: transparent !important;
  i {
    color: #fff !important;
  }
}
</style>